import {Component} from "../../../../../../../sedestral/framework/interface/component/Component";
import * as s from "./offer-blocked-no-permission.scss";
import {Resources} from "../../../../../../../resources/Resources";

export class OfferBlockedNoPermissionComponent extends Component {

    public onClose: () => void = () => {};

    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentOfferBlockedNoPermission}">
                <div class="${s.icon}"></div>
                <div class="${s.title}">
                    ${Resources.t("words.offerBlockedNoPermissionTitle")}
                </div>
                <div class="${s.description}">
                    ${Resources.t("words.offerBlockedNoPermissionDescription")}
                </div>
                <div class="${s.button}">
                    ${Resources.t("words.ok")}
                </div>
            </div>
        `;
    }

    commit() {
        super.commit();
        this.el(s.button).onClick(() => this.onClose());
    }
}
